import React from 'react';
import styles from '../css/ChronicCards.module.css';

/**
 * ChronicCards
 * Presentational row of summary cards shown at the top of the page.
 * Props:
 *  - items: Array<{ id: string|number, title: string, metric: string, subtitle: string, theme?: 'neutral'|'green'|'red'|'purple' }>
 */
const ChronicCards = ({ items = [] }) => {
  return (
    <div className={styles.container}>
      {items.map((item) => (
        <div key={item.id} className={styles.card}>
          <div className={styles.title}>{item.title}</div>
          <div className={`${styles.metric} ${styles[item.theme || 'neutral']}`}>{item.metric}</div>
          <div className={styles.subtitle}>{item.subtitle}</div>
        </div>
      ))}
    </div>
  );
};

export default ChronicCards;

